import { render, staticRenderFns } from "./ReglasUso.vue?vue&type=template&id=36ee7760&scoped=true"
import script from "./ReglasUso.vue?vue&type=script&lang=js"
export * from "./ReglasUso.vue?vue&type=script&lang=js"
import style0 from "./ReglasUso.vue?vue&type=style&index=0&id=36ee7760&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ee7760",
  null
  
)

export default component.exports